<template>
    <div class="order-detail-section mg20" v-if="order.customer != null">
        <h3>用户信息</h3>
        <div class="order-userInfo">
            <div class="userInfo-wrapper">
                <el-row>
                    <el-col :span="12" class="order-item">联系人：<span>{{order.customer.name}}</span>
                    </el-col>
                    <el-col :span="12" class="order-item">联系电话：<span>{{order.customer.mobile}}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">职位：<span>{{order.customer.job_name}}</span>
                    </el-col>
                    <el-col :span="12" class="order-item">QQ：<span>{{order.customer.qq}}</span></el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
    import {OrderMixin} from "~/services/OrderMixin";
    export default {
        mixins:[OrderMixin],
        props:{
            order:{
                required: true
            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_customer_info.vue